const mediaItems = [
  {
    title: '《我独自升级》动画化特辑',
    desc: '韩漫天花板改编，重温经典战斗名场面，从E级猎人到暗影君主的完整成长之路。',
    tag: '热门推荐',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20illustration%20of%20a%20powerful%20warrior%20with%20dark%20shadow%20aura%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20dark%20contrast%20colors%2C%20epic%20fantasy%20scene%2C%20clean%20modern%20composition%2C%20manga%20panel%20style%20background%20elements&width=800&height=500&seq=media-card-01&orientation=landscape',
  },
  {
    title: '2024年度最佳漫画盘点',
    desc: '日漫韩漫国漫年度口碑佳作齐聚，编辑部精选不容错过的必读作品清单。',
    tag: '年度精选',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20collage%20of%20various%20manga%20and%20comic%20book%20covers%20arranged%20creatively%2C%20warm%20lighting%2C%20colorful%20vibrant%20illustrations%2C%20modern%20flat%20design%20style%2C%20cheerful%20reading%20atmosphere%2C%20clean%20background%20with%20subtle%20texture&width=800&height=500&seq=media-card-02&orientation=landscape',
  },
  {
    title: '下拉式阅读新体验上线',
    desc: '全新纵向连续阅读模式，无需翻页自动加载，沉浸式看漫画更流畅更过瘾。',
    tag: '功能更新',
    img: 'https://readdy.ai/api/search-image?query=Modern%20tablet%20device%20displaying%20colorful%20webtoon%20style%20comic%20strips%20in%20vertical%20scrolling%20format%2C%20warm%20orange%20accent%20colors%2C%20clean%20minimal%20background%2C%20cozy%20reading%20environment%2C%20digital%20art%20illustration%20style&width=800&height=500&seq=media-card-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">精彩内容速览</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">热门漫画资讯与平台动态，第一时间掌握漫画世界最新消息</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {mediaItems.map((item) => (
            <div key={item.title} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg mb-4 aspect-[16/10]">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}